import store from '@/store'

export default {
  getTimeStamp() {
    return Date.now()
  },
  getcurTimeStamp() {
    return Date.now() - store.state.offsetTime
  },
}
